import { Fragment } from 'react'

import {
  getTableRowQaProps,
  TableCellFreeSpaceFiller,
  useTableRowModClassName,
} from '../../../../Table'

import { renderApplicantProfileDocumentsCell } from './ApplicantProfileDocumentsRow.utils'

import * as styles from './ApplicantProfileDocumentsRow.module.css'

function ApplicantProfileDocumentsRow({
  columns,
  emptyColumnSize,
  focusedRow,
  getArrowNavigationItemProps,
  index,
  isResizing,
  item,
  resizingColumn,
  showCellBorder,
}) {
  const className = useTableRowModClassName({
    className: styles.ApplicantProfileDocumentsRow,
    isActive: focusedRow === item.id,
  })

  return (
    <div
      {...getTableRowQaProps()}
      {...getArrowNavigationItemProps?.(index)}
      className={className}
    >
      {columns.map(column => (
        <Fragment key={column.name}>
          {renderApplicantProfileDocumentsCell({
            isActive: column.name === resizingColumn,
            isResizing,
            item,
            name: column.name,
            nameCellClassName: styles.nameCell,
            showCellBorder,
            width: column.width,
          })}
        </Fragment>
      ))}
      <TableCellFreeSpaceFiller width={emptyColumnSize} />
    </div>
  )
}

export default ApplicantProfileDocumentsRow
